module.exports = __webpack_public_path__ + "static/hexagonal-architecture-nodejs-migration-2bcc6903c19802b88677bbffb0b9cce8.png";